export default __webpack_public_path__ + "static/media/blog-installing-pavers-banner.e07b5752.jpg";